module.exports = __webpack_public_path__ + "static/img/txhl-logo-white.5b127562.png";